import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-slate-200 dark:bg-slate-800 mx-auto mb-6">
          <i className="ri-map-pin-line text-2xl text-slate-400 dark:text-slate-500" />
        </div>
        <h1 className="text-6xl font-display font-bold text-slate-300 dark:text-slate-700 mb-2">404</h1>
        <p className="text-lg font-semibold text-slate-900 dark:text-white mb-2">{t("notfound_title")}</p>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">{t("notfound_desc")}</p>
        <p className="text-sm text-slate-500 dark:text-slate-500 font-mono mb-6">{location.pathname}</p>
        <div className="flex items-center justify-center gap-3">
          <Link
            to="/"
            className="px-4 py-2 rounded-lg bg-teal text-slate-950 text-sm font-semibold hover:bg-teal-hover transition-colors whitespace-nowrap"
          >
            {t("notfound_back_home")}
          </Link>
          <Link
            to="/login"
            className="px-4 py-2 rounded-lg border border-slate-300 dark:border-slate-700 text-slate-700 dark:text-slate-300 text-sm font-medium hover:border-slate-400 dark:hover:border-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors whitespace-nowrap"
          >
            {t("notfound_back_login")}
          </Link>
        </div>
      </div>
    </div>
  );
}